// // 1.

// import React, { useEffect, useState } from "react";
// import { InverterDetail } from "../../../../../../api/Api";

// import "./Tab5Content.css";
// import { Fullscreen, Refresh } from "@mui/icons-material"; // Import icons
// import IconButton from "@mui/material/IconButton";
// import UpdateInverter from "./UpdateInverter";
// import CancelIcon from '@mui/icons-material/Cancel';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// function parseCustomDate(dateStr) {
//     // format: DD-MM-YYYY HH:mm:ss
//     const [datePart, timePart] = dateStr.split(" ");
//     const [day, month, year] = datePart.split("-").map(Number);
//     const [hour, minute, second] = timePart.split(":").map(Number);
//     return new Date(year, month - 1, day, hour, minute, second);
// }

// export default function DashboardInverterData() {
//     const [logData, setLogData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]); // State for filtered data
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [searchQuery, setSearchQuery] = useState(""); // State for search input
//     const [offlineCount, setOfflineCount] = useState(0);
//     const [onlineCount, setOnlineCount] = useState(0);

//     const [showOfflineOnly, setShowOfflineOnly] = useState(false); // Offlien filter state
//     const [showOnlineOnly, setShowOnlineOnly] = useState(false); // Offlien filter state
//     // this is modal code
//     const [showModal, setShowModal] = useState(false);
//     const [selectedUser, setSelectedUser] = useState(null);

//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 10;

//     const [credentials] = useState({
//         LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//         LOC_CODE: sessionStorage.getItem("LCODE") || "",
//         PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await InverterDetail(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//                 setFilteredData(res.data); // Initialize filtered data
//             } else {
//                 setLogData([]);
//                 setFilteredData([]);
//             }
//         } catch (err) {
//             // console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials.LOGIN_ID]);

//     const handleSearch = () => {
//         const filtered = logData.filter((item) => {
//             return (
//                 Object.values(item)
//                     .join(" ")
//                     .toLowerCase()
//                     .includes(searchQuery.toLowerCase())
//             );
//         });
//         setFilteredData(filtered);
//         setCurrentPage(1); // Reset to the first page
//     };



//     const indexOfLastRow = currentPage * rowsPerPage;
//     const indexOfFirstItem = indexOfLastRow - rowsPerPage;
//     const currentData = filteredData.slice(indexOfFirstItem, indexOfLastRow);
//     const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//     const handlePageChange = (page) => {
//         if (page >= 1 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };


//     // This code for update modal

//     const handleOpenModal = (userData) => {
//         setSelectedUser(userData);
//         setShowModal(true);
//     };

//     const handleClose = () => {
//         setShowModal(false);
//         setSelectedUser(null);
//     };

//     const handleUpdate = (updatedUser) => {
//         setLogData((prevData) =>
//             prevData.map((user) =>
//                 user.USER_ID === updatedUser.USER_ID ? updatedUser : user
//             )
//         );
//         handleClose();
//     };


//     //offline and online
//     // offline and online filter
//     useEffect(() => {
//         let updatedData = logData;

//         if (showOfflineOnly) {
//             // Show only TOT_GEN = 0
//             updatedData = updatedData.filter(item =>
//                 Number(item.KW) === 0
//             );
//         }

//         if (showOnlineOnly) {
//             // Show only TOT_GEN ≠ 0
//             updatedData = updatedData.filter(item =>
//                 Number(item.KW) !== 0
//             );
//         }

//         setFilteredData(updatedData); // ✅ Update table rows
//         setCurrentPage(1); // ✅ Go back to first page after filter
//     }, [showOfflineOnly, logData, showOnlineOnly]);



//     useEffect(() => {
//         const count = logData.filter(item =>
//             Number(item.KW) === 0
//         ).length;
//         setOfflineCount(count);
//     }, [logData]);



//     useEffect(() => {
//         const count = logData.filter(item =>
//             Number(item.KW) !== 0
//         ).length;
//         setOnlineCount(count);
//     }, [logData]);


//     return (

//         <>
//             <div className="w-100 my-1">
//                 <div className="row">
//                     <div className="col-md-12">
//                         {loading && <p>Loading...</p>}
//                         {error && <p style={{ color: "red" }}>{error}</p>}
//                         <div
//                             className="w-100"
//                             style={{
//                                 backgroundColor: "#f8f9fa",
//                                 borderBottom: "2px solid #dee2e6",
//                             }}
//                         >
//                             <div className="d-flex justify-content-between align-items-center px-3">
//                                 <h6
//                                     style={{
//                                         margin: 0,
//                                         fontWeight: "bold",
//                                         color: "#343a40",
//                                     }}
//                                 >
//                                     Inverter Details
//                                 </h6>



//                                 <div className="d-flex align-items-center">
//                                     <button
//                                         className="btn btn-danger mx-1"
//                                         onClick={() => {
//                                             setShowOfflineOnly(true);  // ✅ Correctly enable offline filter
//                                             setShowOnlineOnly(false)
//                                         }}
//                                         style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
//                                     >
//                                         Offline [{offlineCount}]

//                                     </button>

//                                     <button
//                                         className="btn btn-success mx-1"
//                                         onClick={() => {
//                                             setShowOfflineOnly(false);  // ✅ Correctly enable offline filter
//                                             setShowOnlineOnly(true)
//                                         }}
//                                         style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
//                                     >
//                                         Online [{onlineCount}]

//                                     </button>
//                                     {/* Search Input */}
//                                     <input
//                                         type="text"
//                                         className="form-control form-control-sm me-2"
//                                         placeholder="Search..."
//                                         value={searchQuery}
//                                         onChange={(e) => setSearchQuery(e.target.value)}
//                                         style={{ maxWidth: "200px", height: "2.5rem" }}
//                                     />
//                                     {/* Search Button */}
//                                     <button
//                                         className="btn btn-primary "
//                                         onClick={handleSearch}
//                                     // style={{ width: "5rem", height: "2.2rem" }}
//                                     >
//                                         Search
//                                     </button>
//                                     {/* Refresh Button */}
//                                     <IconButton onClick={fetchLogData}>
//                                         <Refresh />
//                                     </IconButton>
//                                     {/* Fullscreen Button */}
//                                     <IconButton>
//                                         <Fullscreen />
//                                     </IconButton>
//                                 </div>
//                             </div>
//                         </div>

//                         <div
//                             className="table-responsive"
//                             style={{
//                                 border: "1px solid #dee2e6",
//                                 borderTop: "none",
//                             }}
//                         >
//                             <table className="table table-striped">
//                                 <thead>
//                                     <tr>
//                                         <th>SN</th>
//                                         <th>ID</th>
//                                         <th>S_ID</th>
//                                         <th>MAC_ID</th>
//                                         <th>NAME</th>
//                                         <th>Make</th>
//                                         <th>Model No</th>

//                                         <th>Capacity</th>
//                                         <th>MF</th>
//                                         <th>Total kWh</th>
//                                         <th>Day kWh</th>

//                                         <th>CUF</th>
//                                         <th>PR</th>
//                                         <th>Date(Time)</th>
//                                         <th>kW</th>
//                                         <th>Latitude</th>
//                                         <th>Longitude</th>
//                                         <th>Alarm/Status</th>

//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {currentData.length > 0 ? (
//                                         currentData.map((log, index) => (
//                                             <tr key={index}>
//                                                 <td>{indexOfFirstItem + index + 1}</td>
//                                                 {/* <td>{log.FEEDER_ID}</td> */}

//                                                 <td
//                                                     className="text-primary text-decoration-none"
//                                                     style={{ cursor: "pointer" }}
//                                                     onClick={() => handleOpenModal(log)}
//                                                 >
//                                                     {log.FEEDER_ID}
//                                                 </td>
//                                                 <td>{log.SID}</td>
//                                                 <td>{log.MAC_ID}</td>
//                                                 <td>{log.NAME}</td>
//                                                 <td>{log.MAKE}</td>
//                                                 <td>{log.MODEL_NO}</td>
//                                                 <td>{log.KWP}</td>
//                                                 <td>{log.MF}</td>
//                                                 <td>{log.TOT_GEN}</td>
//                                                 <td>{log.DAY_KWH}</td>
//                                                 <td>{log.CUF}</td>
//                                                 <td>{log.PR}</td>
//                                                 <td>{log.E_DATE}</td>
//                                                 <td>{log.KW}</td>
//                                                 <td>{log.Latitude}</td>
//                                                 <td>{log.Longitude}</td>
//                                                 <td>{log.ALARM}</td>

//                                               {/* <td
//                                                     className={
//                                                         Number(log.KW) === 0 &&
//                                                             (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000
//                                                             ? "blink"
//                                                             : ""
//                                                     }
//                                                     style={{
//                                                         color:
//                                                             Number(log.KW) === 0 &&
//                                                                 (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000
//                                                                 ? "red"
//                                                                 : "#356E35",
//                                                         fontWeight: "bold",
//                                                     }}
//                                                 >
//                                                     {Number(log.KW) === 0 &&
//                                                         (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000 ? (
//                                                         <>
//                                                             <CancelIcon style={{ fontSize: "1.7rem" }} /> &nbsp; {log.NETWORK}
//                                                         </>
//                                                     ) : (
//                                                         <>
//                                                             <CheckCircleIcon style={{ fontSize: "1.7rem" }} /> &nbsp; {log.NETWORK}
//                                                         </>
//                                                     )}
//                                                 </td> */}


//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="13">No data available</td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>

//                         <div className="d-flex justify-content-center my-3">
//                             <button
//                                 className="btn btn-secondary btn-sm mx-1"
//                                 onClick={() => handlePageChange(currentPage - 1)}
//                                 disabled={currentPage === 1}
//                             >
//                                 Previous
//                             </button>
//                             {[...Array(totalPages).keys()].map((num) => (
//                                 <button
//                                     key={num}
//                                     className={`btn btn-sm mx-1 ${currentPage === num + 1
//                                         ? "btn-primary"
//                                         : "btn-outline-primary"
//                                         }`}
//                                     onClick={() => handlePageChange(num + 1)}
//                                 >
//                                     {num + 1}
//                                 </button>
//                             ))}
//                             <button
//                                 className="btn btn-secondary btn-sm mx-1"
//                                 onClick={() => handlePageChange(currentPage + 1)}
//                                 disabled={currentPage === totalPages}
//                             >
//                                 Next
//                             </button>
//                         </div>

//                     </div>
//                 </div>

//             </div>


//             {/* Pass Props to UpdateComponent */}
//             {showModal && selectedUser && (
//                 <UpdateInverter
//                     show={showModal}
//                     handleClose={handleClose}
//                     userData={selectedUser}
//                     handleUpdate={handleUpdate}
//                 />
//             )}
//         </>

//     );
// }

// 2.

import React, { useEffect, useState } from "react";
import { InverterDetail } from "../../../../../../api/Api";
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../../api/AxiosApi';
import "./Tab5Content.css";
import { Fullscreen, Refresh } from "@mui/icons-material"; // Import icons
import IconButton from "@mui/material/IconButton";
import UpdateInverter from "./UpdateInverter";
import ExportExcel from "../../../../../../components/exportExcel/ExportExcel1";
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';




function parseCustomDate(dateStr) {
    // format: DD-MM-YYYY HH:mm:ss
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
}

export default function DashboardInverterData() {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const [logData, setLogData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // State for filtered data
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
    const [offlineCount, setOfflineCount] = useState(0);
    const [onlineCount, setOnlineCount] = useState(0);

    const [showOfflineOnly, setShowOfflineOnly] = useState(false); // Offlien filter state
    const [showOnlineOnly, setShowOnlineOnly] = useState(false); // Offlien filter state
    // this is modal code
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);



    // const rowsPerPage = 15;

    const [credentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        LOC_CODE: sessionStorage.getItem("LCODE") || "",
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await InverterDetail(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
                setFilteredData(res.data); // Initialize filtered data
            } else {
                setLogData([]);
                setFilteredData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials.LOGIN_ID]);

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const handleSearch = () => {
        const filtered = logData.filter((item) => {
            return (
                Object.values(item)
                    .join(" ")
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
            );
        });
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to the first page
    };





    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;



    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const tableHeaders = [
        { label: "SN", key: "SN" },
        { label: "ID", key: "FEEDER_ID" },
        { label: "S_ID", key: "SID" },
        { label: "MAC_ID", key: "MAC_ID" },
        { label: "NAME", key: "NAME" },
        { label: "Make", key: "MAKE" },
        { label: "Model No", key: "MODEL_NO" },
        { label: "Capacity", key: "KWP" },
        { label: "MF", key: "MF" },
        { label: "Total kWh", key: "TOT_GEN" },
        { label: "Today kWh", key: "DAY_KWH" },
        { label: "CUF", key: "CUF" },
        { label: "PR", key: "PR" },
        { label: "Date(Time)", key: "E_DATE" },
        { label: "Active Power (kW)", key: "KW" },
        // { label: "Latitude", key: "Latitude" },
        // { label: "Longitude", key: "Longitude" },
        { label: "Alarm/Status", key: "ALARM" },
        { label: "Network", key: "NETWORK" },
    ];
   

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // This code for update modal

    const handleOpenModal = (userData) => {
        setSelectedUser(userData);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedUser(null);
    };

    const handleUpdate = (updatedUser) => {
        setLogData((prevData) =>
            prevData.map((user) =>
                user.USER_ID === updatedUser.USER_ID ? updatedUser : user
            )
        );
        handleClose();
    };


    //offline and online
    // offline and online filter
    useEffect(() => {
        let updatedData = logData;

        if (showOfflineOnly) {
            // Show only TOT_GEN = 0
            updatedData = updatedData.filter(item =>
                Number(item.KW) === 0
            );
        }

        if (showOnlineOnly) {
            // Show only TOT_GEN ≠ 0
            updatedData = updatedData.filter(item =>
                Number(item.KW) !== 0
            );
        }

        setFilteredData(updatedData); // ✅ Update table rows
        setCurrentPage(1); // ✅ Go back to first page after filter
    }, [showOfflineOnly, logData, showOnlineOnly]);



    useEffect(() => {
        const count = logData.filter(item =>
            Number(item.KW) === 0
        ).length;
        setOfflineCount(count);
    }, [logData]);



    useEffect(() => {
        const count = logData.filter(item =>
            Number(item.KW) !== 0
        ).length;
        setOnlineCount(count);
    }, [logData]);


    // ✅ Excel Export
    // const exportToExcel = async () => {
    //     await ExportExcel(
    //         ImageUrl,
    //         logData,
    //         "",
    //         "",
    //         `Inverter Details`,
    //         LoggedInUserInfo
    //     );
    // };

    const exportToExcel = async () => {
        const exportData = logData.map((item, index) => {
            let row = {};
            tableHeaders.forEach((header) => {
                if (header.key === "SN") {
                    row[header.label] = index + 1; // Serial number
                } else {
                    row[header.label] = item[header.key] ?? "";
                }
            });
            return row;
        });

        await ExportExcel(
            ImageUrl,
            exportData,
            "", // Start Date if needed
            "", // End Date if needed
            `Inverter_Details`, // File name
            LoggedInUserInfo
        );
    };


console.log("inverterdetail_log",logData)

    return (

        <>
            <div className="w-100 my-1">
                <div className="row">
                    <div className="col-md-12">
                        {loading && <p>Loading...</p>}
                        {error && <p style={{ color: "red" }}>{error}</p>}
                        <div
                            className="w-100"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderBottom: "2px solid #dee2e6",
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-center px-3">
                                <h6
                                    style={{
                                        margin: 0,
                                        fontWeight: "bold",
                                        color: "#343a40",
                                    }}
                                >
                                    Inverter Details
                                    &nbsp;&nbsp;
                                    <select
                                        id="entries"
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(Number(e.target.value));

                                        }}
                                    >
                                        <option value={10}>10</option>

                                        <option value={20}>20</option>

                                        <option value={logData.length}>All</option>
                                    </select>
                                    <span style={{ marginLeft: '8px' }}>entries</span>

                                </h6>




                                <div className="d-flex align-items-center">
                                    <button
                                        className="btn btn-danger mx-1"
                                        onClick={() => {
                                            setShowOfflineOnly(true);  // ✅ Correctly enable offline filter
                                            setShowOnlineOnly(false)
                                        }}
                                        style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                    >
                                        Offline [{offlineCount}]

                                    </button>

                                    <button
                                        className="btn btn-success mx-1"
                                        onClick={() => {
                                            setShowOfflineOnly(false);  // ✅ Correctly enable offline filter
                                            setShowOnlineOnly(true)
                                        }}
                                        style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                    >
                                        Online [{onlineCount}]

                                    </button>
                                    {/* Search Input */}
                                    <input
                                        type="text"
                                        className="form-control form-control-sm me-2"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ maxWidth: "200px", height: "2.3rem" }}
                                    />

                                    <button
                                        className="btn btn-primary btn-sm"
                                        style={{ padding: ".41rem", fontSize: ".8rem", borderRadius: "1rem" }}
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </button>&nbsp; &nbsp;


                                    <button onClick={exportToExcel} className='export-button' style={{ padding: ".41rem", fontSize: ".8rem", borderRadius: "1rem" }}>Excel</button>

                                    {/* Refresh Button */}
                                    <IconButton onClick={fetchLogData}>
                                        <Refresh />
                                    </IconButton>


                                </div>
                            </div>
                        </div>

                        <div
                            className="table-responsive"
                            style={{
                                border: "1px solid #dee2e6",
                                borderTop: "none",
                            }}
                        >
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th style={{ color: "#356E35" }}>SN</th>
                                        <th style={{ color: "#356E35" }}>ID</th>
                                        <th style={{ color: "#356E35" }}>S_ID</th>
                                        <th style={{ color: "#356E35" }}>MAC_ID</th>
                                        <th style={{ color: "#356E35" }}>NAME</th>
                                        <th style={{ color: "#356E35" }}>Make</th>
                                        <th style={{ color: "#356E35" }}>Model No</th>

                                        <th style={{ color: "#356E35" }}>Capacity</th>
                                        <th style={{ color: "#356E35" }}>MF</th>
                                        <th style={{ color: "#356E35" }}>Total kWh</th>
                                        <th style={{ color: "#356E35" }}>Today kWh</th>

                                        <th style={{ color: "#356E35" }}>CUF</th>
                                        <th style={{ color: "#356E35" }}>PR</th>
                                        <th style={{ color: "#356E35" }}>Date(Time)</th>
                                        <th style={{ color: "#356E35" }}>Active Power (kW)</th>
                                        {/* <th style={{ color: "#356E35" }}>Latitude</th>
                                        <th style={{ color: "#356E35" }}>Longitude</th> */}
                                        <th style={{ color: "#356E35" }}>Alarm/Status</th>
                                        <th style={{ color: "#356E35" }}>Network</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? (
                                        currentData.map((log, index) => (
                                            <tr key={index}>
                                                <td>{indexOfFirstItem + index + 1}</td>
                                                {/* <td>{log.FEEDER_ID}</td> */}

                                                <td
                                                    className="text-primary text-decoration-none"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleOpenModal(log)}
                                                >
                                                    {log.FEEDER_ID}
                                                </td>
                                                <td>{log.SID}</td>
                                                <td>{log.MAC_ID}</td>
                                                <td>{log.NAME}</td>
                                                <td>{log.MAKE}</td>
                                                <td>{log.MODEL_NO}</td>
                                                <td>{log.KWP}</td>
                                                <td>{log.MF}</td>
                                                <td>{log.TOT_GEN}</td>
                                                <td>{log.DAY_KWH}</td>
                                                <td>{log.CUF}</td>
                                                <td>{log.PR}</td>
                                                <td>{log.E_DATE}</td>
                                                <td>{log.KW}</td>
                                                {/* <td>{log.Latitude}</td>
                                                <td>{log.Longitude}</td> */}
                                                <td>{log.ALARM}</td>
                                                {/* <td>{log.NETWORK}</td> */}
                                                <td
                                                    className={
                                                        Number(log.KW) === 0 &&
                                                            (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000
                                                            ? "blink"
                                                            : ""
                                                    }
                                                    style={{
                                                        color:
                                                            Number(log.KW) === 0 &&
                                                                (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000
                                                                ? "red"
                                                                : "green",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {Number(log.KW) === 0 &&
                                                        (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000 ? (
                                                        <>
                                                            <CancelIcon style={{ fontSize: "1.7rem" }} /> &nbsp; {log.NETWORK}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <CheckCircleIcon style={{ fontSize: "1.7rem" }} /> &nbsp; {log.NETWORK}
                                                        </>
                                                    )}
                                                </td>
                                                
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="13">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* <div className="d-flex justify-content-center my-3">
                            <button
                                className="btn btn-secondary btn-sm mx-1"
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            {[...Array(totalPages).keys()].map((num) => (
                                <button
                                    key={num}
                                    className={`btn btn-sm mx-1 ${currentPage === num + 1
                                        ? "btn-primary"
                                        : "btn-outline-primary"
                                        }`}
                                    onClick={() => handlePageChange(num + 1)}
                                >
                                    {num + 1}
                                </button>
                            ))}
                            <button
                                className="btn btn-secondary btn-sm mx-1"
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div> */}

                        <div className="d-flex justify-content-center my-3">
                            <button
                                className="btn btn-sm mx-1"
                                style={{
                                    backgroundColor: "#356E35",
                                    color: "white",
                                    border: "none",
                                }}
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>

                            {[...Array(totalPages).keys()].map((num) => (
                                <button
                                    key={num}
                                    className="btn btn-sm mx-1"
                                    style={{
                                        backgroundColor: currentPage === num + 1 ? "#356E35" : "transparent",
                                        color: currentPage === num + 1 ? "white" : "#356E35",
                                        border: `1px solid #356E35`,
                                    }}
                                    onClick={() => handlePageChange(num + 1)}
                                >
                                    {num + 1}
                                </button>
                            ))}

                            <button
                                className="btn btn-sm mx-1"
                                style={{
                                    backgroundColor: "#356E35",
                                    color: "white",
                                    border: "none",
                                }}
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>


                    </div>
                </div>

            </div>


            {/* Pass Props to UpdateComponent */}
            {showModal && selectedUser && (
                <UpdateInverter
                    show={showModal}
                    handleClose={handleClose}
                    userData={selectedUser}
                    handleUpdate={handleUpdate}
                />
            )}
        </>

    );
}


   